import { render } from "./DashboardRollupRiskBadge.vue?vue&type=template&id=1f7eb698"
import script from "./DashboardRollupRiskBadge.vue?vue&type=script&lang=js"
export * from "./DashboardRollupRiskBadge.vue?vue&type=script&lang=js"
script.render = render

export default script